/* eslint no-undef: 'off' */
/* eslint no-console: 'off' */
import $ from "jquery";


const bookingCartUrl = () => {
    const target = ".js-CartHeader";
    const $target = $(target);

    const init = () => {
        if ($target.length) {
            exec();
        }
    };

    const exec = () => {
        const el = {
            cartPopup: '.js-BookingCart__Popup',
            cartPopupOpen: '.js-BookingCart__Popup_BtnOpen',
            cartPopupClose: '.js-BookingCart__Popup_BtnClose',
            cartItem: '.js-BookingCart__Item',
            cartAdd: '.js-BookingCart__Add',
            cartRemove: '.js-BookingCart__Remove',
            cartTable: '.js-BookingCart__Table tbody',
            cartEmptyMsg: '.js-BookingCart__EmptyMsg',
            theCart: '.js-BookingCart__Addons__Card',
            productLists: '.js-ProductLists',
        };

        const urlCart = localStorage.getItem('urlCart');
        const addonsPricesLocalstorage = localStorage.getItem('addonsPrices') || '{}';
        const addonsPrices = JSON.parse(addonsPricesLocalstorage);
        const countProduct = addonsPrices ? Object.keys(addonsPrices).length : 0;


        // const localStorageProductIds = Object.keys(addonsPrices);
        const localStorageProductIds = addonsPrices ? Object.keys(addonsPrices) : [];



        if (urlCart) {
            const ajax = themeObj.get_cart_url;
            
            const data = {
                action: ajax.action,
                nonce: ajax.nonce,
                urlCart: urlCart,
                countProduct: countProduct,
                localStorageProductIds: localStorageProductIds
            };

            $.ajax({
                url: themeObj.ajaxUrl,
                type: "POST",
                data: data,
                success: function (response) {
                    $('.js-CartHeader').addClass('active');
                    $('.js-CartHeader').html(response.data.html); 
                    $('.wb-ProductOverview.Filtered').html(response.data.htmlOverview);
                },
                error: function (error) {
                    console.error("Error sending data", error);
                },
            });

            $('.js-SingleReserverenBtn').addClass('disabled');
            $('.js-SingleReserverenBtn').text('Niet beschikbaar');
        }

        
        

        // DiffDays
        // const reservationDatesData = JSON.parse(localStorage.getItem("reservationDates"));
        const reservationDatesData = JSON.parse(localStorage.getItem("reservationDates")) || { startDate: null, endDate: null };

        

        const start = new Date(reservationDatesData.startDate);
        const end = new Date(reservationDatesData.endDate);
        const timeDifference = end - start;
        let installationFeesByProduct = JSON.parse(localStorage.getItem('installationFeesByProduct')) || {};


        $("#deposit_fee").text('€0');
        const dayDifference = timeDifference / (1000 * 60 * 60 * 24) + 1;
        $('.js-AddonsProduct__DiffDays').val(dayDifference);

         // Add item Single Product
        $('.js-BookingCart__AddSingle').on('click', function() {
            // const reservationDatesData = JSON.parse(localStorage.getItem("reservationDates"));
            const reservationDatesData = JSON.parse(localStorage.getItem("reservationDates")) || { startDate: null, endDate: null };


            const start = (reservationDatesData.startDate);
            const end = (reservationDatesData.endDate);
            
            const diffDayVal = reformatPriceToInt($('.js-AddonsProduct__DiffDays').val());

            const dataProductId = $(this).data('product-id');
        
            const ajax = themeObj.add_to_cart_single_product;

            const installationFeeVal = parseInt($(this).data('instalation')) || 0;
            installationFeesByProduct[dataProductId] = installationFeeVal;
            localStorage.setItem('installationFeesByProduct', JSON.stringify(installationFeesByProduct));
        
            const data = {
                action: ajax.action,
                nonce: ajax.nonce,
                product_id: dataProductId,
                start_date: start,
                end_date: end,
            };
            
            $.ajax({
                url: themeObj.ajaxUrl, 
                method: 'POST',
                data: data,
                success: function(response) {
                    if (response.success) {
                        const $tableHtml = $(response.data.table_html);
                        const $listHtml = $(response.data.list_html);

                        $('.js-BookingCart__AddSingle__Wrapper').html(response.data.button_html);

                        const $specificRow = $tableHtml.filter(`[data-product-id="${dataProductId}"]`);
                        const $specificList = $listHtml.filter(`[data-product-id="${dataProductId}"]`);  
                        
                        if ($specificRow.length) {
                            $(el.cartTable).append($specificRow);
                            $(el.productLists).append($specificList);
                            $(el.cartPopup).removeClass('open');
                            $(el.cartEmptyMsg).removeClass('open');
                            saveToLocalStorage(dataProductId, $specificRow[0].outerHTML, $specificList[0].outerHTML);
                            $(`.js-BookingCart__Card[data-product-id="${dataProductId}"]`).addClass('hide');

                            // Update step1Data in localStorage without replacing existing data
                            const step1Data = JSON.parse(localStorage.getItem('step1Data')) || {};
                            const productIds = step1Data.productIds || [];

                            // Add the new product ID if it's not already in the array
                            if (!productIds.includes(dataProductId)) {
                                productIds.push(dataProductId);
                            }

                            // Update step1Data with the updated productIds array
                            step1Data.productIds = productIds;
                            localStorage.setItem('step1Data', JSON.stringify(step1Data));
                        }

                        calculatePrices()


                        $(".ContentButton__Notification").addClass('active');

                        const currentUrl = new URL(window.location.href);

                        currentUrl.searchParams.delete('startDate');
                        currentUrl.searchParams.delete('endDate');

                        window.history.replaceState({ path: currentUrl.href }, '', currentUrl.href);


                    } else {
                        console.error('Failed to add item:', response.data);
                    }
                },
                error: function(error) {
                    console.error('Error adding item:', error);
                }
            });

            // function calculatePrices() {
            //     const borgSettingVal = reformatPriceToInt($('#deposit_setting').val());
            //     const diffDayValTest = reformatPriceToInt($('.js-AddonsProduct__DiffDays').val());
            
            //     const addonsPricesData = JSON.parse(localStorage.getItem("addonsPrices")) || {};
            //     const pricesArray = Object.values(addonsPricesData);
                
            //     // Retrieve stored installation fees from localStorage
            //     const storedInstallationFees = JSON.parse(localStorage.getItem('installationFeesByProduct')) || {};
            
            //     const calculatedPrices = pricesArray.map((price, index) => {
            //         const productId = Object.keys(addonsPricesData)[index];
            //         const installationFeeVal = storedInstallationFees[productId] || 0;

            //         // let priceEach = price / diffDayValTest;
            //         // let priceDealVal = priceEach + ((diffDayValTest - 1) * (priceEach / 2)) + borgSettingVal;
            //         let priceDealVal = price;
            //         // console.log(priceEach)
            
            //         // Add the specific installation fee from the stored data
            //         priceDealVal += installationFeeVal;
            
            //         return { priceDealVal, installationFeeVal };
            //     });
            
            //     const totalSum = calculatedPrices.reduce((acc, item) => acc + item.priceDealVal, 0);
            //     const totalInstallationFeeTotal = calculatedPrices.reduce((acc, item) => acc + item.installationFeeVal, 0);
            //     const totalSumHuurjs = pricesArray.reduce((acc, price) => acc + price, 0);
            //     const totalBorg = borgSettingVal * pricesArray.length;
            
            //     localStorage.setItem('totalPrice', totalSum);
            //     localStorage.setItem('totalInstallationFee', totalInstallationFeeTotal);
            //     localStorage.setItem('totalBorg', totalBorg);
            //     localStorage.setItem('totalHuurjs', totalSumHuurjs);

            //     // console.log(totalSumHuurjs)
            
            //     $('.js-ReservationPrice.Huurprijs').text(`€${totalSumHuurjs}`);
            //     $('#total_price.totalPrice').text(`€${totalSum}`);
            //     $('#installation_fee').text(`€${totalInstallationFeeTotal}`);
            // }

            function calculatePrices() {
                const borgSettingVal = reformatPriceToInt($('#deposit_setting').val()) || 0;
                const diffDayValTest = reformatPriceToInt($('.js-AddonsProduct__DiffDays').val()) || 1;
            
                const addonsPricesData = JSON.parse(localStorage.getItem("addonsPrices")) || {};
                const pricesArray = Object.values(addonsPricesData) || [];
            
                const storedInstallationFees = JSON.parse(localStorage.getItem('installationFeesByProduct')) || {};
            
                const calculatedPrices = pricesArray.map((price, index) => {
                    const productId = Object.keys(addonsPricesData)[index];
                    const installationFeeVal = storedInstallationFees[productId] || 0;
                    let priceDealVal = price || 0;
            
                    priceDealVal += installationFeeVal;
                    return { priceDealVal, installationFeeVal };
                });
            
                const totalSum = calculatedPrices.reduce((acc, item) => acc + item.priceDealVal, 0);
                const totalInstallationFeeTotal = calculatedPrices.reduce((acc, item) => acc + item.installationFeeVal, 0);
                const totalSumHuurjs = pricesArray.reduce((acc, price) => acc + price, 0);
                const totalBorg = borgSettingVal * pricesArray.length;
            
                localStorage.setItem('totalPrice', totalSum);
                localStorage.setItem('totalInstallationFee', totalInstallationFeeTotal);
                localStorage.setItem('totalBorg', totalBorg);
                localStorage.setItem('totalHuurjs', totalSumHuurjs);
            
                $('.js-ReservationPrice.Huurprijs').text(`€${totalSumHuurjs}`);
                $('#total_price.totalPrice').text(`€${totalSum}`);
                $('#installation_fee').text(`€${totalInstallationFeeTotal}`);
            }
            


            const addonItems = {};
            const addonsItemId = $(this).data('product-id');
            const priceEachItem = $(this).data('product-price') + (($(this).data('product-price')/2) * (diffDayVal - 1));


            if (addonsItemId) {
                addonItems[addonsItemId] = priceEachItem;
            }

            // Update and save addonItems to localStorage
            const existingAddonPrices = JSON.parse(localStorage.getItem('addonsPrices')) || {};
            const updatedAddonPrices = { ...existingAddonPrices, ...addonItems };
            localStorage.setItem('addonsPrices', JSON.stringify(updatedAddonPrices));
            

            // Get the product type from the element's data attribute
            const productTypeItem = {};
            const productTypeId = $(this).data('product-id');
            const productTypeData =  $(this).data('product-type');


            if (productTypeId) {
                productTypeItem[productTypeId] = productTypeData;
            }

            // Update and save addonItems to localStorage
            const existingProductType = JSON.parse(localStorage.getItem('productType')) || {};
            const updatedProductType = { ...existingProductType, ...productTypeItem };
            localStorage.setItem('productType', JSON.stringify(updatedProductType));
        })

        const reformatPriceToInt = (price = "") => {
            if (typeof price !== "string") return 0;
        
            return +price.split(",")[0].replace("€", "").trim();
        };

        

        // Function to save items to localStorage
        function saveToLocalStorage(productId, tableHtml, listHtml) {
            let addonsItem = JSON.parse(localStorage.getItem('addonsItem')) || {};
            addonsItem[productId] = {
                tableHtml: tableHtml,
                listHtml: listHtml
            };
            localStorage.setItem('addonsItem', JSON.stringify(addonsItem));
        }
    };
    
    init();
};

try {
    bookingCartUrl();
} catch (error) {
    throw Error(error);
}
